import { useState } from "react";
import { useGetGroupScheduledMessages } from "../../../App/Queries/MessageQueries";
import { ITableColumn } from "../../../App/Typings/TableColumn";

const columnsNoActionButtons: ITableColumn[] = [
  { label: "Type", propName: "type", order: 0 },
  { label: "State", propName: "messageState", order: 1 },
  { label: "Time Stamp", propName: "scheduledUtcTime", order: 2 },
  { label: "Message", propName: "messageDisplay", order: 3 },
];

export default function MessageHistoryDialogState(groupId?: string, isGroup = false) {
  const [showScheduledMessageDialog, setShowScheduledMessageDialog] = useState(false);
  const { data: scheduledMessages, isLoading: isLoadingScheduledMessages } = useGetGroupScheduledMessages(
    groupId ?? "",
    isGroup
  );

  const handleClose = () => {
    setShowScheduledMessageDialog(false);
  };
  const handleOpen = () => {
    setShowScheduledMessageDialog(true);
  };

  return {
    getters: {
      showScheduledMessageDialog,
      isLoadingScheduledMessages,
      deliveredMessages: scheduledMessages?.groupDeliveredMessages ?? [],
      columnsNoActionButtons,
    },
    setters: {
      setShowScheduledMessageDialog,
    },
    handlers: {
      handleClose,
      handleOpen,
    },
  } as const;
}
